export default __webpack_public_path__ + "45ea2b424049e2f2199e1d88b76d530c.png";